module.exports = __webpack_public_path__ + "static/media/phone-mockup.be548146.png";